import { Activity } from '../../../shared/queries/useGetActivitiesQuery'

const EXTERNAL_SOURCES = ['GSL', 'Planisware']

const IDEATION_STATUS = 'Ideation'

export const isActivityImporting = (activity: Activity) =>
    EXTERNAL_SOURCES.includes(activity.source ?? '') && activity.processingStatus === 'processing'

export const isIdeationActivity = (activity: Activity) =>
    !isActivityImporting(activity) && activity.status === IDEATION_STATUS

export const isEvidenceTacticActivity = (activity: Activity) =>
    !isActivityImporting(activity) && activity.status !== IDEATION_STATUS
